import { getRoutesDirections } from '@/data/libraries/Routes';

import { useLocation } from 'react-router-dom';

import lastPageName from '@/domain/utils/lastPageName';
import { translate } from '@/domain/utils/translate';
import PasswordResetForm from '@/ui/components/user/PasswordResetForm';

import UserOptionsContainer from '@/ui/containers/userOptions/UserOptionsContainer';

/**
 * Componente `UserResetPassword`.
 * 
 * Este componente representa la página de restablecimiento de contraseña del usuario.
 * Utiliza la ubicación actual para generar una lista de migas de pan (breadcrumbs) que 
 * indican la ruta de navegación del usuario.
 * 
 * @returns {JSX.Element} Un elemento JSX que contiene el formulario de restablecimiento de contraseña.
 */
const UserResetPassword = (): JSX.Element => {

    const location = useLocation();

    /** Rutas URLs */
    const routesDirections = getRoutesDirections();
    const breadcumbs = [
        { label: translate('breadcrumbs.home'), url: routesDirections.MAIN_ROUTE },
        { label: translate('breadcrumbs.change_password'), url: routesDirections.CHANGE_PASSWORD_ROUTE },
        { label: translate('breadcrumbs.code'), url: routesDirections.PASSWORD_CODE_ROUTE },
        { label: lastPageName(location.pathname), url: location.pathname }];
    return (

        <UserOptionsContainer type='' breadcumbsList={breadcumbs} >
            <PasswordResetForm />
        </UserOptionsContainer>


    );
};

export default UserResetPassword;